// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"src-components-SdksSection-SdksModal-module__suggestions--2TZja"};